module.exports = __webpack_public_path__ + "static/media/808-snare-02.e0c786e9.wav";